import type { XlsFile } from './xls-file';

export type Mapping = Record<XlsFile['columns'][number], string>;

export type TemplateMatcher = Record<
  string,
  {
    mapping: Mapping;
    colsToHide?: readonly XlsFile['columns'][number][];
  }
>;

export function matchTemplate(
  xlsFile: XlsFile,
  templates: TemplateMatcher
): {
  template: string | null;
  mapping: Mapping;
  colsToHide: XlsFile['columns'][number][];
} {
  const templateEntries = Object.entries(templates);
  for (const [templateName, template] of templateEntries) {
    if (Object.keys(template.mapping).every(key => xlsFile.columns.includes(key))) {
      return {
        template: templateName,
        ...template,
        colsToHide: template.colsToHide ? [...template.colsToHide] : [],
      };
    }
  }

  return { template: null, mapping: {}, colsToHide: [] };
}
